import { SWReactIcons } from "@similarweb/icons";
import type { BaseCellProps } from "@similarweb/pro-logic-components";

import { DATA_AUTOMATION_REGION_VALUE } from "../const";
import { StyledRegionIconContainer, StyledSignleLocationBaseCell } from "../styles";

const RegionCell = ({ children, ...baseCellProps }: Omit<BaseCellProps, "dataAutomation">) => {
    return (
        <StyledSignleLocationBaseCell
            {...baseCellProps}
            dataAutomation={DATA_AUTOMATION_REGION_VALUE}
        >
            <StyledRegionIconContainer>
                <SWReactIcons
                    size="xs"
                    iconName="location-circled"
                />
            </StyledRegionIconContainer>

            {children}
        </StyledSignleLocationBaseCell>
    );
};

export default RegionCell;
